import { z } from 'zod';
import { mongoObjectIdString, optionalMongoObjectId } from '../object-id-helpers.js';

const PoolItemSchema = z.object({
    type: z.enum(['title', 'unit', 'role', 'user']),
    value: z.string().min(1),
    label: z.string().optional(),
}).passthrough();

const TicketDefaultsSchema = z.object({
    title: z.string().optional(),
    description: z.string().optional(),
    priority: z.enum(['critical', 'high', 'medium', 'low']).optional(),
    category: optionalMongoObjectId,
    formData: z.record(z.unknown()).optional(),
    assignedUserIds: z.array(mongoObjectIdString).optional(),
    assignedToPool: z.array(PoolItemSchema).optional(),
}).passthrough();

export const CreateTicketRecurrenceSchema = z.object({
    name: z.string().min(1),
    description: z.string().optional(),
    template: mongoObjectIdString,
    cronExpression: z.string().min(1),
    timezone: z.string().optional(),
    ticketDefaults: TicketDefaultsSchema.optional(),
    autoSubmit: z.boolean().optional(),
    status: z.enum(['active', 'paused', 'inactive']).optional(),
}).passthrough();

export const UpdateTicketRecurrenceSchema = CreateTicketRecurrenceSchema.partial();
